import { z } from 'zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { useTranslate } from 'src/locales';
import { useChannelContext } from 'src/pages/channel/hooks';

import { useConnectFb } from './useConnectFb';

export function useMessengerStep2() {
  const { t } = useTranslate('translation');
  const {
    state: channelState,
    handleChannelName,
    handleFaceBookDeteail,
    onChangeStep,
  } = useChannelContext();
  
  // Extract channelType and channelId for email payload
  const { channelType, channelCreatedResponse } = channelState;
  const channelId = channelCreatedResponse?.id || channelCreatedResponse?.channelId;

  const schema = z.object({
    channelName: z.string().min(1, { message: t('CHANNEL_NAME_REQUIRED') }),
  });

  type FormValues = z.infer<typeof schema>;

  const methods = useForm<FormValues>({
    mode: 'all',
    resolver: zodResolver(schema),
    defaultValues: { channelName: '' },
    values: { channelName: channelState.channelName },
  });

  const { handleSubmit, watch, formState } = methods;

  const channelName = watch('channelName');
  const isFormValid = formState.isValid;

  const { connect, isWhatsappConnectSuccess } = useConnectFb({
    onSuccess: handleFaceBookDeteail,
  });

  // Sync form state to context on change to ensure fresh state for navigation
  useEffect(() => {
    const subscription = watch((value) => {
      if (value.channelName) handleChannelName(value.channelName);
    });
    return () => subscription.unsubscribe();
  }, [watch, handleChannelName]);

  const onSubmit = handleSubmit(async (data) => {
    handleChannelName(data.channelName);
    // methods.reset();  // Do not reset, as we need the data for next steps
    await onChangeStep('next');
  });

  return {
    methods,
    channelName,
    isFormValid,
    isWhatsappConnectSuccess,
    connect,
    onSubmit,
  };
}
